import ClickOutAlertWrapper from "../../wrappers/ClickOutAlertWrapper/ClickOutAlertWrapper";
import { ReactElement, useEffect, useRef, useState } from "react";

import "./TextInputToggleField_style.css";

type Props = {
    label?: string | null | undefined;
    displayFieldStyle?: React.CSSProperties | undefined;
    editorFieldStyle?: React.CSSProperties | undefined;
    isEditable?: boolean;
    value: string;
    onStopEditing?: (val: string) => void;
    onEnterKeyPress?: () => void;
    onLabelClick?: () => void;
};

export default function TextInputToggleField({label, displayFieldStyle, editorFieldStyle, isEditable = true, value, onStopEditing, onEnterKeyPress, onLabelClick}: Props): ReactElement {
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [textValue, setTextValue] = useState<string>(value);

    const ref = useRef(null);

    const textRef = useRef<string>();
    textRef.current = textValue;

    useEffect(() => {
        if (!isEditing) {
            setTextValue(value);
        }
    }, [isEditing, value]);

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
            onEnterKeyPress?.();
        }
    };

    return (
        <div ref={ref} className="text-input-toggle-field-container">
            {label != null && (
                <div className={`label-field${onLabelClick == null ? '' : ' clickable'}`} onClick={onLabelClick}>{label}</div>
            )}
            {isEditing ? (
                <ClickOutAlertWrapper
                    forwardRef={ref}
                    onClickOut={() => {
                        setIsEditing(false);
                        if (textRef.current && textRef.current !== textValue) {
                            onStopEditing?.(textRef.current);
                        }
                    }}
                >
                    <input
                        type="text"
                        className={`editor-field`}
                        style={editorFieldStyle}
                        value={textValue}
                        autoFocus={true}
                        onKeyDown={(event) => {
                            handleKeyDown(event);
                        }}
                        onChange={(e) => {
                            setTextValue(e.target.value);
                        }}
                    />
                </ClickOutAlertWrapper>
            ) : (
                <div
                    className={`display-field${isEditable ? " editable" : ""}${
                        textValue.length === 0 ? " empty" : ""
                    }`}
                    style={displayFieldStyle}
                    onClick={() => {
                        if (isEditable) {
                            setIsEditing(true);
                        }
                    }}
                >
                    {textValue}
                </div>
            )}
        </div>
    );
}
